import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {uiActions} from "../../store/ui/slice";
import {useDispatch, useSelector} from "react-redux";
import {regActions} from "../../store/register/slice";
import {Button, CardContent, Checkbox, FormControlLabel, Grid} from "@mui/material";
import {cartActions} from "../../store/cart/slice";
import {Label} from "@mui/icons-material";
import ProductShippingForm from "./ProductShippingForm";
import {useGetAllProductsQuery, useGetProgramTypeQuery} from "../../store/register/api";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";

const ProductsPage = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const registrations = useSelector(state => state.cart.registrations);
    //todo: only one product per camper per program (I believe if they have multiple sessions in the same program for the same camper, they should only be able to purchase one product)
    const campers = useSelector(state => state.cart.campers);
    const products = useSelector(state => state.cart.products);

    const [sessionsWithProducts, setSessionsWithProducts] = useState([]);

    const {
        data: allProducts,
        error: allProductsError,
        isFetching: isFetchingProducts,
        isSuccess: isSuccessProducts,
        isError: isErrorProducts,
        refetch: refetchProducts,
    } = useGetAllProductsQuery();

    useEffect(() => {
        dispatch(uiActions.setBackAction(handleBack));
        dispatch(uiActions.setBackText("BACK"));
        refetchProducts();
    }, []);

    useEffect(() => {
        //after fetching all available products, filter out any that are stored in the cart but are no longer available
        if (isSuccessProducts) {
            //a list of products is fetched with each session upon adding it to the cart, so one or more of those products may no longer be available
            registrations.forEach(reg => {
                reg.products.forEach(product => {
                    //if the product is no longer available, remove it from the session
                    if (!allProducts.find(p => p.id === product.id)) {
                        dispatch(cartActions.removeProductFromSession({camperKey: reg.camperKey, sessionId: reg.id, productId: product.id}));
                    }
                });
            });
        }
    }, [isSuccessProducts]);

    useEffect(() => {
        let swp = registrations.filter(reg => reg.products.length > 0);
        setSessionsWithProducts(swp);
        if (swp.length === 0) {
            //no products are available for purchase, so continue to checkout
            navigate("/checkout");
        }
    }, [registrations]);

    const handleBack = () => {
        dispatch(regActions.setupChooseRegisterAction());
        navigate("/");
    };

    if (isFetchingProducts) {
        return (
            <div>
                <h1>Loading Products...</h1>
            </div>
        );
    }

    if (isErrorProducts) {
        return (
            <div>
                <h1>Error Loading Products</h1>
                <p>{allProductsError}</p>
            </div>
        );
    }

    return isSuccessProducts ? (
        <>
            {allProducts.map(product => {
                //if there are no sessions that have this product, don't display it
                if (!sessionsWithProducts.find(reg => reg.products.find(p => p.id === product.id))) {
                    return null;
                }
                return (
                    <div style={{paddingBottom: "30px"}}>
                        <h1>{product.name}</h1>
                        <Grid container direction="row" spacing={2} sx={{width: "100%"}}>
                            <Grid item xs={7}>
                                <Typography sx={{color: "gray", fontSize: "14pt", paddingTop: "20px", height: "100%"}}>{product.description}</Typography>
                            </Grid>
                            <Grid item xs={5}>
                                <img src={product.image_path} alt={product.name} style={{maxHeight: "160px"}}/>
                            </Grid>
                        </Grid>
                        <div>
                            {sessionsWithProducts.map(reg => {
                                //if the session doesn't have this product, don't display it
                                if (!reg.products.find(p => p.id === product.id)) {
                                    return null;
                                }
                                return (
                                    <Card sx={{ width: "100%", borderRadius: 0, marginTop: "20px" }}>
                                        <CardContent
                                            sx={{
                                                padding: "1rem 1rem 1rem 1rem",
                                                "&:last-child": { paddingBottom: "1rem" },
                                            }}
                                        >
                                            <ProductShippingForm product={product} camperKey={reg.camperKey} programSessionId={reg.id} camperName={`${campers.find(camper => camper.key === reg.camperKey).firstName} ${campers.find(camper => camper.key === reg.camperKey).lastName}`} />
                                        </CardContent>
                                    </Card>
                                )
                            })}
                        </div>
                    </div>
                )})
            }
            <Button
                variant="contained"
                onClick={() => navigate("/checkout")}
                sx={{ height: "50px", width: "100%" }}>
                Next
            </Button>
            <p style={{fontSize: "10pt", color: "gray", textAlign: "center", marginTop: "10px"}}>Product sales are final and non-refundable.</p>
        </>
    ) : (<div><h1>Loading Products...</h1></div>);
}

export default ProductsPage;
